<template>
    <div>
        <title-lines :text="text" style="white-space: pre-line"></title-lines>
    </div>
</template>

<script>
    Vue.component('title-lines', {
        props: [
            'text'
        ],

        render(createElement) {
            let parts = _.split(this.text, '\n');

            let lines = [];
            for (let i=0; i< parts.length; ++i) {
                if (i == 1) {
                    lines.push(createElement('span', parts[i]));
                }
                else {
                    lines.push(createElement('div', parts[i]));
                }
            }

            return createElement('div', lines);
        },
        mounted() {
        }
    });

    export default {
        props: [
            'text'
        ]
    }
</script>
